import { render, staticRenderFns } from "./SuspendedTenantOverlay.vue?vue&type=template&id=0ca2fdda&scoped=true"
import script from "./SuspendedTenantOverlay.vue?vue&type=script&lang=js"
export * from "./SuspendedTenantOverlay.vue?vue&type=script&lang=js"
import style0 from "./SuspendedTenantOverlay.vue?vue&type=style&index=0&id=0ca2fdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2fdda",
  null
  
)

export default component.exports